<template>
    <Row :gutter="40">
        <Col span="12" style="margin-bottom: 40px;" >
            <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
                <div class="title">
                    <div class="inline-block"></div>
                    <p style="display: inline-block;vertical-align: top;">云联律师经常办公地的全国分布图</p>
                </div>
            </div>
            <div style="background-color: #fff;" :style="{width: '580px', height: '333px'}">
                <mapChart></mapChart>
            </div>
        </Col>
        <Col span="12" style="margin-bottom: 40px;" >
            <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
                <div class="title">
                    <div class="inline-block"></div>
                    <p style="display: inline-block;vertical-align: top;">云联律师擅长业务领域的分布图</p>
                </div>
            </div>
            <div style="background-color: #fff;" id="field" :style="{width: '580px', height: '333px'}"></div>
        </Col>
        <Col span="12" style="margin-bottom: 40px;" >
            <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
                <div class="title">
                    <div class="inline-block"></div>
                    <p style="display: inline-block;vertical-align: top;">云联律师学历结构图</p>
                </div>
            </div>
            <div style="background-color: #fff;" id="education" :style="{width: '580px', height: '333px'}"></div>
        </Col>
        <Col span="12" style="margin-bottom: 40px;" >
            <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
                <div class="title">
                    <div class="inline-block"></div>
                    <p style="display: inline-block;vertical-align: top;">执业年限结构图</p>
                </div>
            </div>
            <div style="background-color: #fff;" id="years" :style="{width: '580px', height: '333px'}"></div>
        </Col>
    </Row>
</template>

<script>
    import mapChart from '../../components/data/mapChart'
    export default {
        name: "chart1",
        components: {mapChart:mapChart,},
        data (){
            return{
                chart: null,
                field : '',
                education :'',
                years :'',
            }
        },
        props: {
            msg : String
        },
        methods : {
            echartsField(){
                var _this = this
                _this.field = this.$echarts.init(document.getElementById('field'))
                _this.field.setOption({
                    title : {
                        x:'center'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    series : [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius : '90px',
                            center: ['50%', '50%'],
                            data:[
                                {value:335, name:'经济'},
                                {value:310, name:'房产'},
                                {value:234, name:'刑事'},
                                {value:135, name:'合同'},
                                {value:1548, name:'其他'}
                            ],
                            label: {
                                // formatter: '{b}: {@2012} ({d}%)'
                                formatter: '{d}% \n {b}'
                            },
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })
                _this.field.resize();
            },
            echartsEducation(){
                var _this = this
                _this.education = this.$echarts.init(document.getElementById('education'))
                _this.education.setOption({
                    title : {
                        x:'center'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    series : [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius : '90px',
                            center: ['50%', '50%'],
                            data:[
                                {value:335, name:'硕士'},
                                {value:310, name:'硕士及以上'},
                                {value:234, name:'研究生'},
                                {value:135, name:'大学'},
                            ],
                            label: {
                                // formatter: '{b}: {@2012} ({d}%)'
                                formatter: '{d}% \n {b}'
                            },
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })
                _this.education.resize();
            },
            echartsYears(){
                var _this = this
                _this.years = this.$echarts.init(document.getElementById('years'))
                _this.years.setOption({
                    title : {
                        x:'center'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    series : [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius : '90px',
                            center: ['50%', '50%'],
                            data:[
                                {value:335, name:'硕士'},
                                {value:310, name:'硕士及以上'},
                                {value:234, name:'研究生'},
                                {value:135, name:'大学'},
                            ],
                            label: {
                                // formatter: '{b}: {@2012} ({d}%)'
                                formatter: '{d}% \n {b}'
                            },
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })
                _this.years.resize();
            },
        },
        mounted () {
            this.echartsField()
            this.echartsEducation()
            this.echartsYears()
        },
    }
</script>

<style scoped>
    .title{font-size: 16px;color: #00a2e9;display: inline-block;line-height: 66px;padding: 0 24px;}
    .title div{width: 4px;height: 18px;background-color: #00a2e9;display: inline-block;margin-right: 5px;vertical-align: text-bottom;}
</style>
